import "../Styles/Footer.css";
import mark from "../Images/mark.png";
import GitHubIcon from "@mui/icons-material/GitHub";

export default function Footer() {
  return (
    <footer className="footer">
      <hr className="footer-line"></hr>
      <div className="footer-div">
        <a href="https://pixelmanic.dev" className="footer-one-div">
          <img src={mark} alt="Pixel Manic" />
          <span>Design & Development</span>
        </a>
        <div className="footer-two-div">
          <a
            href="https://github.com/pixelmanic/pixelmanic-portfolio.git"
            rel="noreferrer"
            target="_blank"
          >
            <GitHubIcon />
          </a>
        </div>
      </div>
    </footer>
  );
}
